<template>
  <div class="pos-relative">
    <SectionPageTitle
      v-if="!MOBILE_APP"
      title="Posts"
      :actions="hasAccess(route.params._id, 'posts', 'create', auth.state.accesses, auth.state.access.roles)
        ? [{ method: () => $router.push({ name: routePrefix + 'CreateBlogPost', params: { _id: route.params._id } }), label: '+', class: 'radius-extra i-big hover:scale-[1.05] cursor-pointer t-white bg-second' }]
        : []"
      :tabs="route.meta.context === 'backoffice'
        ? [
            { name: 'Published', value: 'published' },
            { name: 'Drafts', value: 'drafts' },
          ]
        : null"
      :tabs_current="tab"
      @update:tabs_current="tab = $event"
      class="pd-medium pd-b-zero"
    />

    <div class="w-100 rows-1 pd-medium pos-relative o-hidden">
        <Feed
          :search="true"
          v-model:filter="blog.state.filter"
          v-model:sort="blog.state.sort"
          :showLoadMore="false"
          :states="{
            empty: {
              title: 'No Blog Posts Found',
              description: 'Currently, there are no posts available in this blog.'
            }
          }"
          :store="{
            read: (options) => blog.read(options),
            state: blog.state
          }"
          :options="{
            limit: 12,
            status: tab === 'drafts' ? 'draft' : 'published',
            user: auth.state.user._id,
            owner: route.params._id || null,
            search: route.query.search
          }"
          v-slot="{ 
            items 
          }"
          class="cols-1 pos-relative w-100 rows-1 gap-thin"
        >
          <CardBlogpost 
            v-for="item in items" 
            :key="item._id" 
            :blogpost="item" 
            :user="auth.state.user._id" 
            class="h-max-40r bg-light radius-medium cursor-pointer"
            @click="$router.push({
              name: routePrefix + 'BlogPost',
              params: {
                _id: route.params._id,
                url: item.url
              }
            })"
          />
        </Feed>

    </div>
  </div>
</template>

<script setup="props">
  // Import libs
  import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  // Import components
  import Feed from '@martyrs/src/design-system/components/Feed/Feed.vue'
  import SectionPageTitle from '@martyrs/src/modules/core/views/components/sections/SectionPageTitle.vue'

  import CardBlogpost from '@martyrs/src/modules/community/components/blocks/CardBlogpost.vue'

  import IconPlus from '@martyrs/src/modules/icons/navigation/IconPlus.vue'

  // Accessing router and store
  import * as auth from '@martyrs/src/modules/auth/views/store/auth.js';
  import { useStore } from '@martyrs/src/modules/core/views/store/core.store.js';
  import * as blog from '@martyrs/src/modules/community/store/blogposts.js';
  import * as organizations from '@martyrs/src/modules/organizations/store/organizations.js';
  import { useGlobalMixins } from '@martyrs/src/modules/core/views/mixins/mixins.js';
  const store = useStore();

  const route = useRoute()
  const router = useRouter()
  const { hasAccess } = useGlobalMixins()

  const routePrefix = computed(() => {
    const ctx = route.meta.context
    if (ctx === 'organization') return 'Organization'
    return ''
  })

  const tab = ref(route.query.tab || 'published')

  watch(tab, (newValue) => {
    router.replace({ query: { ...route.query, tab: newValue } });
  })

  // Props
  const props = defineProps({
    organization: {
      type: Object,
      default: null
    }
  })


  store.core.state.navigation_bar.actions = [{
    component: IconPlus,
    props: {
      fill: "rgb(var(--main))"
    },
    condition: () => auth.state.user && auth.state.user._id,
    action: () => router.push({ name: routePrefix.value + 'CreateBlogPost', params: { _id: route.params._id } })
  }]

  onMounted(async () => {
    if (route.params._id) {
      await organizations.actions.read({ _id: route.params._id });
    }
  })

  onUnmounted(() => {
    store.core.state.navigation_bar.actions = [];
  });
</script>

<style lang="scss">
</style>